<template>
    <div>
        <f7-list class="form-group">
            <f7-list-input
                :id          ="listId"   
                :input-id    ="name"
                :name        ="name"
                type         ="tel"
                class        ="mobile-input"
                :label       ="label"
                placeholder  =""
                :value       ="name == 'mobileNo' ? update.tempCurrMobileNo : update.tempNewMobileNo"
                @input       ="mobileNo = $event.target.value; setVal($event.target.value); validateInput();"
                maxlength    ="15"
                outline
                required
                floating-label
                clear-button
            >
                <f7-link :id="linkId" :popover-open="'.popover-'+name" slot="content-start" class="flag-with-chevron" >
                    <img :src="name == 'mobileNo' ? getFlagImg(update.tempCurrMobileCountryCodeId) : getFlagImg(update.tempNewMobileCountryCodeId)" class="" />
                    <span class="">{{ name == 'mobileNo' ? update.tempCurrMobileCountryCodeIdd : update.tempNewMobileCountryCodeIdd }} </span>
                </f7-link>        
            </f7-list-input>
        </f7-list>

        <MobilePhonePopover
            :name="name"
            :countryList="countryList"
            :mobileCountryId="mobileCountryId"
            :popoverDropdown="popoverDropdown"
            :searchbarId="searchbarId"
            :linkId="linkId"
            @changeMobilePhoneCode="changeMobilePhoneCode"
        />
    </div>
</template>

<script>
import { check } from '@/plugins/helper';
import { mapGetters, mapActions } from "vuex";
import MobilePhonePopover from './account-mobile-phone-popover.vue';

export default {
    props: [
        'listId',
        'linkId',
        'name',
        'label',
        'countryList',
        'popoverDropdown',
        'searchbarId'
    ],
    mounted (){
        const sgCountry = this.countryList.filter(country => country.countryId == 189);
        this.mobileCountryId = sgCountry.length>0?sgCountry[0].countryId:189;
        this.mobileCountryCode = sgCountry.length>0?sgCountry[0].countryIDD:'+65';

        if(this.update.tempCurrMobileNo.trim() != "" || this.update.tempNewMobileNo.trim() != ""){
            this.validateInput()
        }
    },
    data: function () {
        return {
            mobileNo: '',
            mobileCountryId: 0,
            mobileCountryCode: ''
        }
    },
    computed: {
        ...mapGetters('customer', [
            'update',
        ])
    },
    components: {
        MobilePhonePopover
    },
    methods: {
        ...mapActions('customer', [
            'setUpdateTempCurrMobileCountryCode',
            'setUpdateTempNewMobileCountryCode',
            'setUpdateTempCurrMobileNo',
            'setUpdateTempNewMobileNo',
        ]),

        setVal(val){
            if(this.name == "mobileNo"){
                this.setUpdateTempCurrMobileNo(val)
            }else{ // newMobileNo
                this.setUpdateTempNewMobileNo(val)
            }
        },

        validateInput(){
            var regex   = /^[0-9]{8,15}$/;
            var validate = false;

            if(this.name == "mobileNo"){
                if(this.update.tempCurrMobileCountryCodeId == 189) { // SG
                    validate = check.validPattern("mobilephone189", this.update.tempCurrMobileNo);
                }else{
                    validate = regex.test(this.update.tempCurrMobileNo);
                }
            }else{ // newMobileNo
                if(this.update.tempNewMobileCountryCodeId == 189) { // SG
                    validate = check.validPattern("mobilephone189", this.update.tempNewMobileNo);
                }else{
                    validate = regex.test(this.update.tempNewMobileNo);
                }
            }

            if(!validate){
                this.setInputState(this.name, this.$t('ua-mobile-incorrect'));        
            } else {
                this.setInputState(this.name, true);
            }

            let tempMobileNo = "";
            let tempMobileCountryCodeId = 0;
            let tempMobileCountryCodeIdd = "";
            if(this.name == "mobileNo"){
                tempMobileNo = this.update.tempCurrMobileNo;
                tempMobileCountryCodeId = this.update.tempCurrMobileCountryCodeId;
                tempMobileCountryCodeIdd = this.update.tempCurrMobileCountryCodeIdd;
            }else{ // newMobileNo
                tempMobileNo = this.update.tempNewMobileNo;
                tempMobileCountryCodeId = this.update.tempNewMobileCountryCodeId;
                tempMobileCountryCodeIdd = this.update.tempNewMobileCountryCodeIdd;
            }

            //console.log("tempMobileNo: "+tempMobileNo)
            //console.log("tempMobileCountryCodeId: "+tempMobileCountryCodeId)
            //console.log("tempMobileCountryCodeIdd: "+tempMobileCountryCodeIdd)
            

            this.$emit("validateInput", {name: this.name, mobileNo: tempMobileNo, mobileCountryId: tempMobileCountryCodeId, mobileCountryCode: tempMobileCountryCodeIdd, isValidate: validate });
        },

        changeMobilePhoneCode(country) {
            this.mobileCountryId = country.countryId;
            this.mobileCountryCode = country.countryIDD;

            if(this.name == "mobileNo"){
                this.setUpdateTempCurrMobileCountryCode({id: country.countryId, idd: country.countryIDD})
            }else{ // newMobileNo
                this.setUpdateTempNewMobileCountryCode({id: country.countryId, idd: country.countryIDD})
            }
            
            this.validateInput();
        }
    }
}
</script>